import { render, staticRenderFns } from "./memberbalance.vue?vue&type=template&id=3120e67d&"
import script from "./memberbalance.vue?vue&type=script&lang=js&"
export * from "./memberbalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports